import { DownloadAuthoringPdfMenuItem } from "authoring/routes/pdf/download-authoring-pdf-menu-item"

export function DownloadSideBySidePdf() {
    return (
        <DownloadAuthoringPdfMenuItem
            mode="side-by-side"
            label="Download internal PDF: side-by-side (includes internal notes)"
            dataCy="download-side-by-side-pdf-menu-item"
        />
    )
}
